import {
  SET_PAYMENT_DATA,
  RESET_PAYMENT_DATA,
  SET_MAILING_ID_PROMO,
  SET_PROMO_ID_FROM_CHAT,
} from '../../constants/actions';
import config from '../../constants/config';
import { saveMailingIdToStorage } from '../../assets/helpers/upgradeHelper';

const initialState = {
  subscription: {},
  paymentMethod: config.ROCKET_GATE,
  billingData: {
    cardName: '',
    cardNumber: '',
    cardMonth: '',
    cardYear: '',
    cardCvv: '',
    tosAccepted: false,
  },
  paypalData: {},
  routeToReturn: '',
  emailPromo: '',
  mailingId: '',
  welcomeBackPromo: false,
  stepdownIndex: -1,
  promoId: null,
};

export default function reducer(state = initialState, action = {}) {
  const currentState = { ...state };
  switch (action.type) {
    case SET_PAYMENT_DATA:
      const { data } = action;
      if (data.billingData) {
        currentState.billingData[data.key] = data.value;
      } else {
        currentState[data.key] = data.value;
      }
      return currentState;
    case SET_MAILING_ID_PROMO:
      const { emailPromo, mailingId } = action.data;
      if (mailingId) {
        saveMailingIdToStorage(mailingId);
      }
      return { ...currentState, emailPromo, mailingId };
    case RESET_PAYMENT_DATA:
      return {
        subscription: {},
        paymentMethod: config.ROCKET_GATE,
        billingData: {
          cardName: '',
          cardNumber: '',
          cardMonth: '',
          cardYear: '',
          cardCvv: '',
          tosAccepted: false,
        },
        paypalData: {},
        routeToReturn: '',
        emailPromo: '',
        mailingId: '',
        welcomeBackPromo: false,
        stepdownIndex: -1,
        promoId: null,
      };
    case SET_PROMO_ID_FROM_CHAT:
      return { ...state, promoId: action.promoId };
    default:
      return state;
  }
}
